module.exports = __webpack_public_path__ + "img/server.234249ff.png";